module.exports = __webpack_public_path__ + "static/img/15.defeea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/15.jpg
// module id = CRva
// module chunks = 1